
export const bankingDepositHasFiscalDocumentOptions = [
  { label: 'Sim', value: 'true' },
  { label: 'Não', value: 'false' },
];
